import { useQuery } from "@tanstack/react-query";
import { fetchProfile } from "@/api/profile/profile";
import { useAuth } from "@/providers/auth";

export const useProfile = ({
  id,
  enabled,
  queryKey,
  queryFn,
  ...config
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  let userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  userId = id || userId;
  const isEnabled = !!userId && enabled !== false;

  return useQuery({
    queryKey: ["profile", userId],
    queryFn: () => fetchProfile(userId),
    enabled: isEnabled,
    ...config,
  });
};
